module.exports = __webpack_public_path__ + "static/media/Payment.3a75ca33.svg";